//Generated File 
export default class ApprovalCaseState{
	static readonly Approved = `Approved`;
	static readonly InProgress = `InProgress`;
	static readonly Rejected = `Rejected`;
	static readonly Returned = `Returned`;
	static readonly Revoked = `Revoked`;
}
